import React from 'react';
import { Button, Icon, Text } from '@msc-b2c/shared-components';
import styles from './chooseWhenBookStep.module.scss';
import { managePlurals, replacePlaceholders } from '@msc-b2c/shared-utils';
import { DiningReservationMode, HeadsUpIconAlignment } from '@msc-b2c/interfaces/enums';
import { ChooseWhenBookStepProps } from '@msc-b2c/interfaces/interfaces';
import HeadsUpInfo, { HeadsUpMessagePriority } from '../../../HeadsUpInfo';
import RadioGroup from './RadioGroup';
import clsx from 'clsx';
export function ChooseWhenBookStep({
  title,
  reservationMode,
  isReserveNowDisabled = false,
  onSelectNow,
  onSelectLater,
  onEditPassengers,
  reserveNowLabel,
  reserveLaterLabel,
  passengersLabel,
  editLabel,
  editIcon,
  selectedPassengersCount = 0,
  infoMessageTitle,
  infoMessageBody,
  infoMessageIcon,
  makeReservationButtonLabel,
  onMakeReservation,
  infoMessageBgColor,
  infoMessageFontColor,
  loading = false,
}: Readonly<ChooseWhenBookStepProps>) {
  const isReserveNowSelected = reservationMode === DiningReservationMode.WITH_TIMESLOT;
  // Format the description
  const passengerSummaryLabel = replacePlaceholders(
    managePlurals(selectedPassengersCount, passengersLabel),
    {
      numberOfPassengers: `${selectedPassengersCount}`,
    }
  );

  return (
    <div className={clsx(styles['choose-when-book-step'], { '-loading': loading })}>
      {selectedPassengersCount > 0 && (
        <div className={styles['choose-when-book-step__passengers-summary']}>
          <Text
            text={passengerSummaryLabel}
            styleOption={clsx(
              'body-bold',
              styles['choose-when-book-step__passengers-summary--title']
            )}
          />
          {onEditPassengers && (
            <div className={styles['choose-when-book-step__passengers-summary--action']}>
              <Button
                text={editLabel ?? ''}
                onClick={onEditPassengers}
                styleOption="cmp-button__link"
              />
              <Icon icon={editIcon ?? ''} />
            </div>
          )}
        </div>
      )}
      {!!title && (
        <Text
          text={title}
          styleOption={clsx('header-xs', styles['choose-when-book-step__title'])}
        />
      )}
      {infoMessageTitle && (
        <HeadsUpInfo
          icon={infoMessageIcon ?? ''}
          title={infoMessageTitle}
          description={infoMessageBody ?? ''}
          priority={HeadsUpMessagePriority.DEFAULT}
          visibilityCondition={() => true}
          bgColor={infoMessageBgColor}
          fontColor={infoMessageFontColor}
          iconAlignment={HeadsUpIconAlignment.TOP}
        />
      )}
      <RadioGroup
        options={[
          {
            label: reserveNowLabel ?? '',
            value: DiningReservationMode.WITH_TIMESLOT,
            disabled: isReserveNowDisabled,
          },
          {
            label: reserveLaterLabel ?? '',
            value: DiningReservationMode.WITHOUT_TIMESLOT,
          },
        ]}
        name="reservation-time"
        selectedValue={reservationMode}
        onChange={(value) => {
          if (value === DiningReservationMode.WITH_TIMESLOT) {
            onSelectNow();
          } else {
            onSelectLater();
          }
        }}
      />
      <div className={styles['choose-when-book-step__dining-next']}>
        <Button
          text={makeReservationButtonLabel ?? ''}
          onClick={onMakeReservation}
          disabled={!isReserveNowSelected || isReserveNowDisabled}
          styleOption="cmp-button__primary -extended"
        />
      </div>
    </div>
  );
}

export default ChooseWhenBookStep;
